export default "__VITE_PUBLIC_ASSET__d4bf735c__"